import React from 'react';

import { InjectReducerArgs } from '../utils/injectReducer';
import getInjectors from '../utils/reducerInjectors';
import StoreInstance from '../utils/StoreInstance';

const useInjectReducer = ({ key, reducer }: InjectReducerArgs): void => {
  React.useEffect(() => {
    getInjectors(StoreInstance.store).injectReducer(key, reducer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useInjectReducer;
